import { GatewayConformite } from "@conformite/gateway";
import {
  Dropdown,
  displayErrorToast,
  displaySucessToast,
} from "@endya-conformite/ui-kit";
import DownloadIcon from "@endya-conformite/ui-kit/src/assets/icons/download.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import { gatherAssujettiQuestionnaireExport } from "@src/data/assujetti/assujettiQuestionnaireExport";
import {
  exportAssujettisQuestionnaireToCsv,
  exportAssujettisQuestionnaireToExcel,
} from "@src/helper/excel/exportAssujettisList.helper";
import { useState } from "react";
import styles from "./ExportAssujettisListButton.module.scss";

type ExportAssujettisListButtonProps = {
  availableAxes: GatewayConformite.AxeConformite[];
  siren: string;
  millesime: number;
};

export function ExportAssujettisListButton({
  availableAxes,
  siren,
  millesime,
}: ExportAssujettisListButtonProps) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (exportFormat: "excel" | "csv") => {
    setIsExporting(true);
    try {
      const data = await gatherAssujettiQuestionnaireExport(
        siren,
        millesime,
        availableAxes
      );
      if (exportFormat === "excel") {
        await exportAssujettisQuestionnaireToExcel(data, { siren, millesime });
      } else {
        exportAssujettisQuestionnaireToCsv(data, { siren, millesime });
      }
      displaySucessToast(
        "La liste des personnes assujetties a été téléchargée."
      );
    } catch {
      displayErrorToast("Impossible de générer l'export de la liste.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Dropdown
      content="Exporter"
      icon={isExporting ? <Loader /> : <DownloadIcon />}
      variant="text"
      placement="bottom-end"
      dismissOnClick
    >
      {({ close }) => (
        <div className={styles.menuContent}>
          <button
            type="button"
            className={styles.menuItem}
            disabled={isExporting}
            onClick={() => {
              handleExport("excel").catch(() => {});
              close();
            }}
          >
            Excel (.xlsx)
          </button>
          <button
            type="button"
            className={styles.menuItem}
            disabled={isExporting}
            onClick={() => {
              handleExport("csv").catch(() => {});
              close();
            }}
          >
            CSV (.csv)
          </button>
        </div>
      )}
    </Dropdown>
  );
}
